import React, { useEffect, useState } from 'react';
import './Message.css';

export default function MyNotification(

    {
        image,
        title,
        body,
    }:
        {
            image: any,
            title: any,
            body: any,
        }) {


    return (
        <>
            <div id="notificationHeader">
                {/* image is optional */}
                {image && (
                    <div id="imageContainer">
                        <img src={image} width={100} />
                    </div>
                )}
                <span>{title}</span>
            </div>
            <div id="notificationBody">{body}</div>
        </>
    )
}
